module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "nav-address",
    class: {
      active: _vm.isActive
    }
  }, [_vm._v("\n    " + _vm._s(_vm.address) + "\n")])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-402f64e8"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/NavAddress.vue
// module id = 51
// module chunks = 0